import "./css/SectionFeatures.css";

import "../../assets/animation/add_bookmark-svg.css";
import { ReactComponent as TrackSvg1 } from "../../assets/add_bookmark.svg";
import "../../assets/animation/metrics-svg.css";
import { ReactComponent as TrackSvg2 } from "../../assets/metrics.svg";

function SectionFeatures() {
  return (
    <section className="section-feature">
      <div className="feature-container landing-container">
        <h2 className="section-heading">Features</h2>
        <div className="feature">
          <div className="text">
            <h3>Track your health data</h3>
            <p>
              Easily input and record essential health metrics such as blood
              pressure, heart rate, body temperature, and more. Our
              user-friendly interface makes it simple to log your data, ensuring
              you never miss a beat on your health journey.
            </p>
          </div>
          <div className="graphic">
            <TrackSvg1 />
          </div>
        </div>
        <div className="feature">
          <div className="graphic">
            <TrackSvg2 />
          </div>
          <div className="text">
            <h3>Visualize Your Progress</h3>
            <p>
              PhysioTrack translates your data into visual representations,
              allowing you to visualize progress and track improvements over
              time. Stay motivated and make data-driven decisions to optimize
              your well-being.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SectionFeatures;
